import React, { useState, useEffect, useContext, createContext, ReactNode } from 'react';

import { createRestClient } from '../api/restClient';
import { useCustomer as useIsGuest } from '../components/Header/customer/redux/hooks';

interface Customer {
    firstName: string;
    lastName: string;
    phone: string | null;
    email: string;
}

interface CustomerContext {
    isLoading: boolean;
    customer: Customer | null;
}

const defaultCustomerContext = {
    isLoading: false,
    customer: null,
};

const customerContext = createContext<CustomerContext>(defaultCustomerContext);
//TODO add to customer redux and service
const useFetchCustomer = () => {
    const [isLoading, setIsLoading] = useState<boolean>(false);
    const [customer, setCustomer] = useState<Customer | null>(null);

    useEffect(() => {
        const fetchCustomerData = async () => {
            setIsLoading(true);
            await createRestClient('/api/phoenix/customer', '/me')
                .get('')
                .then(response => response.json())
                .then(({ error, ...customerData }) => {
                    if (error) {
                        throw new Error(error);
                    }
                    setCustomer(customerData);
                })
                .catch(() => setCustomer(null));

            setIsLoading(false);
        };

        fetchCustomerData();
    }, []);

    return { isLoading, customer };
};

const _CustomerProvider = ({ children }: { children: ReactNode }) => {
    const customerContextValue = useFetchCustomer();

    return (
        <customerContext.Provider value={customerContextValue}>{children}</customerContext.Provider>
    );
};

export const CustomerProvider = ({ children }: { children: ReactNode }) => {
    const isGuest = useIsGuest();

    if (isGuest) {
        return (
            <customerContext.Provider value={defaultCustomerContext}>
                {children}
            </customerContext.Provider>
        );
    }

    // eslint-disable-next-line react/jsx-pascal-case
    return <_CustomerProvider>{children}</_CustomerProvider>;
};

export const useCustomer = () => useContext(customerContext);
